export const DEPLOYMENT = process.env.REACT_APP_BRANCH;
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID!;
export const AUTH_SIGN_UP_SIGN_IN_AUTHORITY = process.env.REACT_APP_AUTH_SIGN_UP_SIGN_IN_AUTHORITY!;
export const AUTH_DOMAIN_AUTHORITY = process.env.REACT_APP_AUTH_DOMAIN_AUTHORITY!;
export const AUTH_REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI!;
export const AUTH_POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_AUTH_POST_LOGOUT_REDIRECT_URI!;
export const AUTH_LOGIN_REQUEST_SCOPES = process.env.REACT_APP_AUTH_LOGIN_REQUEST_SCOPES!.split(' ') || [];
export const AUTH_API_CONFIG_SCOPES = process.env.REACT_APP_AUTH_API_CONFIG_SCOPES!.split(' ') || [];
export const AUTH_API_CONFIG_URI = process.env.REACT_APP_AUTH_API_CONFIG_URI!;

// Base URL for the Python import service. In Aspire-driven local dev this
// is the uvicorn endpoint (https://localhost:8000); in deployed environments
// it'll be the Container App's public URL.
export const IMPORT_SERVICE_URL = process.env.REACT_APP_IMPORT_SERVICE_URL || "https://localhost:8000";
